module.exports = __webpack_public_path__ + "static/Patria Abditiar-9e3ae80ab5d863602f8b833fd9cf78c1.jpeg";